import styled from 'styled-components'
import CardButton from 'views/VvsGotchi/components/CardButton'

export const GotchiTaskButton = styled(CardButton)<{ grayout?: boolean }>`
  justify-content: center;
  align-items: center;
  height: 165px;
  background-repeat: no-repeat;
  padding: 11px;
  gap: 12px;
  background-size: cover;
  ${({ grayout, theme }) =>
    grayout
      ? `
    background-color: ${theme.colors.lightBeige};
    border: 3px solid ${theme.colors.darkGrey};
  `
      : `
    background-color: white;
    border: 3px solid ${theme.colors.darkestNightBlue};
  `}
`

export const StyledButtonLabel = styled.div<{ type: 'locked' | 'success' }>`
  position: absolute;
  font-size: 11px;
  ${({ type, theme }) => type === 'success' && `background: ${theme.colors.gotchiSuccessGreen};`}
  ${({ type }) => type === 'locked' && `background: black;`}
  right: -3px;
  top: 0;
  transform: translateY(-15px);
  padding: 8px;
  border-radius: 8px;
`
